// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ew-page-header[data-v-211a12e8]{width:100%;height:57px;position:fixed;top:0;left:0;right:0;z-index:2}.ew-page-header .logo[data-v-211a12e8]{position:fixed;top:20px;left:20px}.ew-page-header .logo>a[data-v-211a12e8]{display:block}.ew-page-header .logo .logo-img[data-v-211a12e8]{width:auto;height:63px}", ""]);
// Exports
module.exports = exports;
